import { Coins, Network, ShieldAlert, FileBarChart, Code2 } from "lucide-react";

const FEATURES = [
  { id: "token-analysis", icon: Coins, title: "Token Analysis", span: "lg:col-span-2",
    body: "Supply, decimals, token program, mint and freeze authorities, holder distribution and liquidity indicators, pulled directly from Solana and market indexers.",
    points: ["Mint & freeze authority", "Supply distribution", "Token-2022 extensions"] },
  { id: "wallet-intelligence", icon: Network, title: "Wallet Intelligence",
    body: "Creator activity, top-holder wallets and potential connections between addresses. Confirmed data and inferred relationships are always labelled separately.",
    points: ["Confirmed vs inferred", "Creator transactions"] },
  { id: "risk-indicators", icon: ShieldAlert, title: "Risk Indicators",
    body: "Concentrated holdings, thin liquidity, unusual sell activity and more. Each indicator explains why it matters and shows its evidence. No score guarantees safety.",
    points: ["Evidence for every flag", "Plain-language reasoning"] },
  { id: "clear-reports", icon: FileBarChart, title: "Clear Reports",
    body: "One dashboard instead of ten tabs. Every section shows its data source and the time it was retrieved.",
    points: ["Source attribution", "Update timestamps"] },
  { id: "developer-tools", icon: Code2, title: "Developer Tools", planned: true, span: "lg:col-span-2",
    body: "A planned API to let developers and trading tools query supported TRACE analytics programmatically. Not yet available.",
    points: ["REST endpoints", "Risk & holder data"] },
];

const FeatureCard = ({ f, i }) => (
  <article data-testid={`feature-${f.id}`} style={{ animationDelay: `${i * 80}ms` }}
    className={`fade-up group relative rounded-xl border border-trace-line bg-trace-card/60 p-7 transition-colors duration-300 hover:border-trace-green/30 hover:bg-trace-hover ${f.span || ""}`}>
    <div className="flex items-start justify-between">
      <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-trace-line bg-trace-panel text-trace-green transition-transform duration-300 group-hover:-translate-y-0.5">
        <f.icon size={18} />
      </span>
      {f.planned && <span className="rounded-full border border-amber-500/40 px-2.5 py-0.5 font-mono text-[10px] uppercase tracking-wider text-amber-300">Planned</span>}
    </div>
    <h3 className="mt-6 text-xl font-medium tracking-tight text-white">{f.title}</h3>
    <p className="mt-3 text-sm leading-relaxed text-trace-muted">{f.body}</p>
    <ul className="mt-5 flex flex-wrap gap-2">
      {f.points.map((p) => <li key={p} className="rounded-md bg-trace-panel px-2.5 py-1 font-mono text-[11px] text-trace-dim">{p}</li>)}
    </ul>
  </article>
);

export const Features = () => (
  <section id="features" className="scroll-mt-20 border-b border-trace-line py-24 lg:py-32" data-testid="features-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid gap-6 lg:grid-cols-[1fr_1.2fr] lg:items-end">
        <div>
          <p className="eyebrow">01 — Platform</p>
          <h2 className="mt-4 text-3xl font-semibold tracking-[-0.02em] text-white sm:text-4xl">Blockchain intelligence,<br />without the noise.</h2>
        </div>
        <p className="max-w-xl text-base text-trace-muted md:text-lg">
          TRACE brings the on-chain facts that matter into one interface, and tells you exactly where each one came from.
        </p>
      </div>
      <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3">
        {FEATURES.map((f, i) => <FeatureCard key={f.id} f={f} i={i} />)}
      </div>
    </div>
  </section>
);
